<template>
	<div class="asd" >
		<el-form
			:label-position="labelPosition"
			:rules="rules"
			ref="ruleForm"
      class="form"
			label-width="185px"
			:model="formLabelAlign">
			<div class="shang">
        <div class="dianpu">
          <div>
            <el-form-item label="店铺名称" width="100"  prop="name">
              <el-input v-model="formLabelAlign.name" placeholder="请输入店铺名（15字以内）"  :maxlength="15"  style="width:350px"></el-input>
            </el-form-item>

            <el-form-item label="商家手机号" width="100" prop="phone" style="display:inline-block;">
              <el-input v-model="formLabelAlign.phone" placeholder="请输入商家手机号" @blur="dongjie(formLabelAlign.phone)" :maxlength="11"  style="width:350px"></el-input>
            </el-form-item>
          </div>
          <div class='upload'>
            <el-form-item label="店铺头像" width="100" >
              <!-- <el-upload
                action="https://up-z1.qbox.me"
                class="avatar-uploader"
                :show-file-list="false"
                :on-change="LocalUrl"
                :on-success="handleAvatarSuccess"
                :auto-upload="false"
                 ref="upload"
                :data="uploadToken"
                >
                <img v-if="imageUrl" :src="imageUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload> -->
              <ul class='imagesList'>
                <li class="imagesItem" v-for='(item, index) in imagesList' :key='index'>
                  <img class='img' :src="item" alt width="100%" height='100%'/>
                  <img class='del' src="../../assets/images/fail.png" alt="" @click='delImages(index)'>
                </li>
              </ul>
              <div v-show='!imagesList.length' @click="handleUploadImages(1)" class="picture">
                <img src="../../assets/images/addImages.png" alt width="100%" height='100%'/>
              </div>
		        </el-form-item>
          </div>
        </div>
				<el-form-item label="详细地址" width="100" prop="address" >
					<el-input  v-model="formLabelAlign.address"  placeholder="请输入店铺的详细地址" style="width: 100%"></el-input>
				</el-form-item>

				<el-form-item label="店铺描述" width="100" >
					<el-input  v-model="formLabelAlign.description"  type="textarea" :rows="6" :maxlength="255" placeholder="请输入对店铺的详细店铺描述（500字以内）" style="width:100%;font-size:16px;"></el-input>
				</el-form-item>
			</div>
			<div class="zhong"></div>
			<div class="xia">
				<el-form-item label="园区钱包结算周期" width="140"  >
					<el-select v-model="formLabelAlign.feeId"  v-show="isShow"  placeholder="请选结算周期" @click="getRate"  style="width:350px">
							   <el-option
									v-for="item in options"
                  :key="item.feeId"
									:label='item.feeTpl'
									:value="item.feeId" >
								</el-option>
					</el-select>
          <div  v-show="!isShow" style="width:350px">
                <span class="day">T+{{formLabelAlign.day}}</span>
                <span  class="day" >{{formLabelAlign.feeRate}}%</span>
                <el-button  type="primary" class="button1"  @click="ensureEditFeeDialogOpen = true;isShow = true">修改</el-button>
          </div>
				</el-form-item>
        <el-form-item label="第三方平台结算周期" width="140"  >
					<el-select v-model="formLabelAlign.thirdFeeId"  v-show="isShowOther"  placeholder="请选结算周期" @click="getRate"  style="width:350px">
							   <el-option
									v-for="item in optionOther"
                  :key="item.feeId"
									:label='item.feeTpl'
									:value="item.feeId" >
								</el-option>
					</el-select>
          <div  v-show="!isShowOther" style="width:350px">
                <span class="day">T+{{formLabelAlign.thirdDay}}</span>
                <span  class="day" >{{formLabelAlign.thirdFeeRate}}%</span>
                <el-button  type="primary" class="button1"  @click="ensureEditFeeDialogOpen = true;isShowOther = true">修改</el-button>
          </div>
				</el-form-item>

				<el-form-item label="银行名称" width="140"  prop="bankName">
					<el-input v-model="formLabelAlign.bankName" placeholder="请输入银行名称"   style="width:350px"></el-input>
				</el-form-item>
        </div>
        <div class="xia1">
				<el-form-item label="银行卡账号" width="140"  prop="bankAccountNo">
					<el-input v-model="formLabelAlign.bankAccountNo" placeholder="请输入银行卡号" :maxlength="19"   style="width:350px"></el-input>
				</el-form-item>

				<el-form-item label="持卡人姓名" width="140" prop="bankAccountName"  >
					<el-input v-model="formLabelAlign.bankAccountName"  placeholder="请输入提现银行卡持卡人姓名" style="width:350px"></el-input>
				</el-form-item>
			</div>
      <div class="zhong"></div>
        <!-- <p class="xuanTian">选填</p>
        <el-form-item label="店铺管理员" width="100"   class="admin" >
          <div v-for=" (iteam ,index) in  num" class="input1" :key="index">
                	<el-input   v-model="iteam.val" @blur="dongjie(iteam.val)" placeholder="请输入店铺管理员手机号" :maxlength="11" ></el-input>
                  <el-button v-if="index==0?false:true" type="text" class="delinput" @click="DelInput(index)">删除</el-button>
                  <div v-if="index==0?true:false"  style="height:40px;width:57px"></div>
          </div>

          <div>
            <el-button  type="text"  @click="AddInput()">添加<span style="color:#323232;">（可添加多个）</span></el-button>
          </div>
				</el-form-item> -->
			<el-button  type="success" :disabled="subButton" class="button" @click="submitForm('ruleForm')">保 存</el-button>
		</el-form>
    <el-dialog
      title="提示"
      :visible.sync="ensureEditFeeDialogOpen"
      width="30%"
      >
      <span>若修改，新的结算周期将会立即生效，商户将会按照新的风险预存期和费率进行提现。</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="ensureEditFeeDialogOpen = false;isShow = false;isShowOther = false;">考虑一下</el-button>
        <el-button type="primary" @click="ensureEditFeeDialogOpen = false;">继续修改</el-button>
      </span>
    </el-dialog>
	</div>
</template>

<script>
import { quillEditor } from "vue-quill-editor"; //调用编辑器
import { validateTel } from "@/utils/validate";
import {
  getRate,
  AddMerchant,
  Mercompile,
  updataMer,
  freezes
} from "@/api/merchant/merchManage";
import {
  getUploadToken,
  getUploadId
} from "../../api/companyApi/company";
import A from "../../assets/upload";
export default {
  name: "Add",
  props: [""],
  mixins: [A],
  data() {
    //验证
    const valiPhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error("电话不能为空"));
      } else if (!validateTel(value)) {
        return callback(new Error("请输入正确手机号"));
      } else {
        callback();
      }
    };
    //验证
    const valiPhone2 = (rule, value, callback) => {
      console.log(value);
      if (!validateTel(value)) {
        return callback(new Error("请输入正确手机号"));
      } else {
        callback();
      }
    };
    const valiName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("店铺名称不能为空"));
      } else {
        callback();
      }
    };
    const bankName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("银行卡名称不能为空"));
      } else {
        callback();
      }
    };
    const bankAccountName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("持卡人行姓名不能为空"));
      } else {
        callback();
      }
    };
    const bankAccountNo = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("银行卡号不能为空"));
      } else if (isNaN(value)) {
        callback(new Error("请输入数字值"));
      } else {
        callback();
      }
    };
    const address = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("详细不能为空"));
      } else {
        callback();
      }
    };
    const rateTpl = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("周期模板不能为空"));
      } else {
        callback();
      }
    };
    return {
      ensureEditFeeDialogOpen:false,
      account:0,//当前编辑商户的余额
      subButton:false,
      flag1: true,
      yanzhengPhone: true,
      dongjiePhone: "",
      flag: true,
      imageUrl: "",
      imageUr2: "",
      uploadToken: { token: "" },
      num: [{ val: "" }],
      options: [],//feeId 园区提现周期
      optionOther: [],//feeId 第三方平台提现周期
      isShow: true,
      isShowOther: true,
      labelPosition: "right",
      rules: {
        phone: [{ validator: valiPhone, trigger: "blur" }],
        phone2: [{ validator: valiPhone2, trigger: "blur" }],
        name: [{ validator: valiName, trigger: "blur" }],
        bankAccountNo: [{ validator: bankAccountNo, trigger: "blur" }],
        bankAccountName: [{ validator: bankAccountName, trigger: "blur" }],
        bankName: [{ validator: bankName, trigger: "blur" }],
        address: [{ validator: address, trigger: "blur" }],
        rateTpl: [{ validator: rateTpl, require: true, trigger: "change" }]
      },
      formLabelAlign: {
        name: "",
        region: "",
        type: "",
        bankName: "",
        address: "",
        phone: "",
        bankAccountNo: "",
        description: "",
        bankAccountName: "",
        feeId: "",
        thirdFeeId:'',
        feeRate: "",
        day: ""
      },
      imagesList: []
    };
  }, 
  mounted() {
    this.account = this.$route.query.account;
    this.$on('upload-finish', (data) => {
      let { isupdate } = data;
      // console.log(data);
      if(!data) return;
      if(this.imagesList.length > 1) {
        this.$message('最多上传1张图');
        return;
      }
      this.imagesList.push(data.src); 
    });
  },
  methods: {
    dongjie(phone) {
      let _this = this;
      if (validateTel(phone)) {
        freezes(phone)
          .then(function(res) {
            if (res.data.result == 1) {
              for (var i = 0; i < _this.num.length; i++) {
                _this.flag = true;
                if (_this.num[i].val == _this.formLabelAlign.phone) {
                  _this.$message.error("店铺管理员手机号与商家手机号不可一致");
                  _this.flag = false;
                }
              }
            } else {
              _this.$message.error("您输入的手机号已被冻结，请重新填写");
              _this.flag1 = false;
              _this.dongjiePhone = phone;
            }
          })
          .catch(function(error) {
            this.$message({
              type: "error",
              message: "请求出错，请重新加载"
            });
          });
      } else if (phone) {
        //手机号有空的情况
        this.$message.error("您输入的手机有误，请重新填写");
        if (phone.length !== 0) {
          this.yanzhengPhone = false;
        }
      }
    },
    //上传头像部分
    LocalUrl(file) {
      this.imageUrl = file.url;
    },
    handleUploadImages(index) {
      let option = {
        multiple: !1,
        params: {
          isupdate: index,
          region: "ap-chongqing",
          bucket: "range-smartpark-1304188286",
          previewUrl: "https://cdn.shop.rangepark.cn"
        },
        getFileId: getUploadId,
        getAuthFunction: getUploadToken,
        accept: "image/*"
      };
      this.handleClickUpload(option);
    },
    //获取图片路径
    getImageSrc() {
      if (!this.imagesList.length) {
        this.$message('上传图片不能为空');
        return;
      } else {
        return this.imagesList;
      }
    },
    delImages(index) {
      this.imagesList.splice(index, 1);
      // console.log(this.imagesList);
    },
    handleAvatarSuccess(res, file) {
       this.subButton=false
      this.$router.push({ name: "商户管理" });
    },
    upToQiniu(res) {
      this.uploadToken.token = res;
      this.$refs.upload.submit();
    },
    // beforeAvatarUpload(file) {
    // const isJPG = file.type === "image/jpeg";
    // const isLt2M = file.size / 1024 / 1024 < 2;

    // if (!isJPG) {
    //   this.$message.error("上传头像图片只能是 JPG 格式!");
    // }
    // if (!isLt2M) {
    //   this.$message.error("上传头像图片大小不能超过 2MB!");
    // }
    // return isJPG && isLt2M;
    // },
    /* 因为不需要添加管理员功能了，所以这两个方法暂时无用了 */
    AddInput() {
      this.num.push({ val: "" });
    },
    DelInput(index) {
      if (this.num.length > 1) {
        this.num.splice(index, 1);
      }
    },
    /* 获得园区钱包提现费率 */
    getRate() {
      let _this = this;
      getRate(1).then(function(res) {
        for (var i = 0; i <= res.data.length - 1; i++) {
          _this.options.push({
            feeId: res.data[i].feeId,
            feeTpl: "T+" + res.data[i].day + " " + res.data[i].feeRate + "%"
          });
        }
      });
    },
    /* 获得第三方平台提现费率 */
    getOtherRate(){
      let _this = this;
      getRate(2).then(function(res) {
        for (var i = 0; i <= res.data.length - 1; i++) {
          _this.optionOther.push({
            feeId: res.data[i].feeId,
            feeTpl: "T+" + res.data[i].day + " " + res.data[i].feeRate + "%"
          });
        }
      });
    },
    submitForm(formName) {
      let shuju = [];
      for (var i = 0; i < this.num.length; i++) {
        shuju.push(this.num[i].val);
      }
      //防止input不失去焦点就点 保存
      for (var i = 0; i < this.num.length; i++) {
        this.flag = true;
        if (this.num[i].val == this.formLabelAlign.phone) {
          this.$message.error("店铺管理员手机号与商家手机号不可一致");
          this.flag = false;
        }
      }
      let managerPhones = shuju.join(",");
      let feeId = this.formLabelAlign.feeId;
      if(this.isShow&&!feeId){
        this.$message.error("必须选择一个园区钱包结算周期");
        return;
      }
      let thirdFeeId = this.formLabelAlign.thirdFeeId;
      if(this.isShowOther&&!thirdFeeId){
        this.$message.error("必须选择一个第三方平台结算周期");
        return;
      }
      if(!this.imagesList.length){
        this.$message.error("必须上传一个logo");
        return;
      }
      let name = this.formLabelAlign.name;
      let address = this.formLabelAlign.address;
      let description = this.formLabelAlign.description;
      let bankName = this.formLabelAlign.bankName;
      let bankAccountName = this.formLabelAlign.bankAccountName;
      let bankAccountNo = this.formLabelAlign.bankAccountNo;
      let phone = this.formLabelAlign.phone;
      let logo = this.imagesList[0];
      let _this = this;
      let MerchId = this.$route.query.mchId;
      if (this.yanzhengPhone) {
        if (this.flag1) {
          if (this.flag) {
            this.$refs[formName].validate(valid => {
              this.subButton=true
              if (valid) {
                if (MerchId) {//目前的写法是根绝是否存在Merchid这个值，来判断是修改还是新增商户
                  updataMer(
                    MerchId,
                    name,
                    address,
                    description,
                    bankName,
                    bankAccountName,
                    bankAccountNo,
                    phone,
                    managerPhones,
                    feeId,
                    thirdFeeId,
                    logo
                  )
                    .then(res=> {
                      if (res.data.msg == "success") {
                         _this.$message({
                          type: "success",
                          message: "商户修改成功!"
                        });
                        _this.subButton=false
                        _this.$router.push({ name: "商户管理" });
                        // return res.data.uploadToken;
                      }
                    })
                    // .then(res=>{
                    //   if (_this.imageUrl == _this.imageUr2) {
                    //     _this.$message({
                    //       type: "success",
                    //       message: "商户修改成功!"
                    //     });
                    //      _this.subButton=false
                    //     _this.$router.push({ name: "商户管理" });
                    //   } else {
                    //     _this.upToQiniu(res);
                    //   }
                    // })
                    .catch(error => {
                       _this.subButton=false
                      let msg = "请求出错！";
                      if (error.response.data) {
                        msg = error.response.data.msg || "请求出错";
                      }
                      this.$message({
                        type: "error",
                        message: msg
                      });
                    });
                } else {
                  // let that = this;
                  // if (this.imageUrl == "") {
                  //   this.$message({
                  //     type: "error",
                  //     message: "请添加头像"
                  //   });
                  //    _this.subButton=false
                  // } else {
                    AddMerchant(
                      feeId,
                      thirdFeeId,
                      name,
                      address,
                      description,
                      bankName,
                      bankAccountName,
                      bankAccountNo,
                      phone,
                      managerPhones,
                      logo
                    )
                      .then(function(res) {
                        console.log(res,1111);
                        _this.$message({
                          type: "success",
                          message: '添加成功'
                        });
                        _this.subButton=false
                        _this.$router.push({ name: "商户管理" });
                        // return res.data.uploadToken;
                      })
                      .then(function(res) {
                        // this.$message({
                        //   type: "success",
                        //   message: '添加成功'
                        // });
                        // _this.subButton=false
                        // _this.$router.push({ name: "商户管理" });
                        // _this.upToQiniu(res);
                      })
                      .catch(error => {
                        console.log(error,2222);
                         _this.subButton=false
                        let msg = "请求出错！";
                        if (error.response.data) {
                          msg = error.response.data.msg || "请求出错";
                        }
                        this.$message({
                          type: "error",
                          message: msg
                        });
                      });
                  // }
                }
              } else {
                 _this.subButton=false
                console.log("error submit!!");
                return false;
              }
            });
          } else {
            this.$message.error("店铺管理员手机号与商家手机号不可一致");
          }
        } else {
          this.$message.error(
            "您输入的手机号" + this.dongjiePhone + "已被冻结"
          );
        }
      } else {
        this.$message.error("店铺管理员手机号有误");
      }
    },
    //编辑商户
    getMerchantInfo(MerchId) {
      let _this = this;
      if (MerchId) {
        //商户数据回显
        Mercompile(MerchId).then(function(res) {
          _this.isShow = false;
          _this.isShowOther = false;
          _this.formLabelAlign.name = res.data.name;
          _this.formLabelAlign.bankAccountName = res.data.bankAccountName;
          _this.formLabelAlign.bankAccountNo = res.data.bankAccountNo;
          _this.formLabelAlign.bankName = res.data.bankName;
          _this.formLabelAlign.day = res.data.day;
          _this.formLabelAlign.thirdDay = res.data.thirdDay;
          _this.formLabelAlign.description = res.data.description;
          _this.formLabelAlign.phone = res.data.phone;
          _this.formLabelAlign.feeRate = res.data.feeRate;
          _this.formLabelAlign.thirdFeeRate = res.data.thirdFeeRate;

          _this.formLabelAlign.address = res.data.address;
          _this.imagesList.push(res.data.logo);
          _this.imageUr2 = res.data.logo;
          for (var i = 0; i < res.data.managers.length; i++) {
            _this.num[i] = { val: res.data.managers[i] };
          }
        });
      }
    }
  },
  created() {
    this.getRate();
    this.getOtherRate();
    let MerchId = this.$route.query.mchId;
    this.getMerchantInfo(MerchId);
  }
};
</script>

<style scoped="scoped" lang='scss'>
.asd {
  background-color: white;
  height: 100%;
  text-align: left;
  padding-top: 30px;
}
.shang {
  padding-left: 30px;
  margin-bottom: 50px;
  width: 69%;
}
.xia {
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
  padding-left: 10px;
  width: 80%;
  flex-wrap: wrap;
}
.form {
  min-width: 1280px;
}
.xia1 {
  display: flex;
  justify-content: space-between;
  padding-left: 10px;
  width: 80%;
}
.admin {
  margin-left: 30px;
}
.zhong {
  height: 1px;
  width: 100%;
  background-color: rgb(230, 230, 230);
}
.dianpu {
  display: flex;
  justify-content: space-between;
}
.button {
  margin-left: 113px;
  width: 150px;
  font-size: 18px;
  margin-bottom: 10px;
  margin-top: 10px;
}
.button1 {
  width: 80px;
  font-size: 14px;
  float: right;
}
.day {
  display: inline-block;
  padding-left: 80px;
}
.input1 {
  margin-bottom: 10px;
  display: flex;
  width: 350px;
}
.delinput {
  color: red;
  padding-left: 20px;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader {
  height: 102px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;

  border: 1px solid #e4e0e0;
  border-radius: 3px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader-icon:hover {
  border-color: #409eff;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
.xuanTian {
  color: red;
  margin-left: 30px;
}
.upload{
  /deep/ .el-form-item__content{
    display: flex;
    .imagesList{
      display: flex;
      margin:0;
      padding-left:0;
      .imagesItem{
        list-style-type: none;
        padding-right: 20px;
        position: relative;
        .img{
          width: 85px;
          height: 85px;
          // border: 1px solid #f0f0f0;
        }
        .del{
          width:20px;
          height:20px;
          position: absolute;
          top:-10px;
          right:10px;
        }
      }
    }
    .picture {
      width: 85px;
      height: 85px;
      border: 1px solid #f0f0f0;
      padding:20px;
      box-sizing: border-box;
      img{
        width:100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/merchant/addMerchant.vue